'use es6';

import PropTypes from 'prop-types';
import React from 'react';
import { memoize } from 'underscore';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UIBanner from 'UIComponents/alert/UIBanner';
import UIButton from 'UIComponents/button/UIButton';
import UIButtonWrapper from 'UIComponents/layout/UIButtonWrapper';
import UILink from 'UIComponents/link/UILink';
import UISection from 'UIComponents/section/UISection';
import UITrialActivationButton from 'ui-addon-upgrades/button/UITrialActivationButton';
import HubspotUrls from '../../constants/HubspotUrls';
import { getAppBaseUrl } from '../../utils/utils';
var getI18nKey = memoize(function (path) {
  return "MarketplaceUI.goodDetailsPage.ctaBanner." + path;
});

var getUrl = function getUrl(path) {
  return getAppBaseUrl() + "/" + path;
};

var TrialBanner = function TrialBanner(_ref) {
  var canTrialMarketing = _ref.canTrialMarketing,
      isCustomer = _ref.isCustomer,
      partial = _ref.partial,
      trackLinkClick = _ref.trackLinkClick,
      urlToken = _ref.urlToken;
  var redirectPath = encodeURIComponent(getUrl("l/marketplace/products/" + urlToken));
  var trialType = 'marketing-pro';
  var trialButton = isCustomer && canTrialMarketing ? React.createElement(UITrialActivationButton, {
    upgradeData: {
      app: 'marketplace',
      screen: 'goods-details',
      upgradeProduct: 'marketing-pro',
      uniqueId: 'banner'
    },
    size: "extra-small",
    use: "primary-white",
    shouldHideSurvey: true,
    onSuccess: function onSuccess() {
      window.location.reload();
    }
  }) : React.createElement(UIButton, {
    external: true,
    href: HubspotUrls.FREE_TRIAL,
    onClick: partial(trackLinkClick, 'free-trial'),
    size: "extra-small",
    use: "primary-white"
  }, React.createElement(FormattedMessage, {
    message: getI18nKey('buttonText')
  }));
  return React.createElement(UISection, null, React.createElement(UIBanner, {
    titleText: React.createElement(FormattedMessage, {
      message: getI18nKey(trialType + ".title")
    })
  }, React.createElement(UIButtonWrapper, null, isCustomer ? React.createElement(FormattedMessage, {
    message: getI18nKey(trialType + ".message")
  }) : React.createElement(FormattedJSXMessage, {
    message: getI18nKey(trialType + ".message_jsx"),
    options: {
      href: getUrl("login?loginRedirectUrl=" + redirectPath),
      use: 'on-dark'
    },
    elements: {
      Link: UILink
    }
  }), trialButton)));
};

TrialBanner.propTypes = {
  canTrialMarketing: PropTypes.bool.isRequired,
  isCustomer: PropTypes.bool.isRequired,
  partial: PropTypes.func.isRequired,
  trackLinkClick: PropTypes.func.isRequired,
  urlToken: PropTypes.string.isRequired
};
export default TrialBanner;